import React, { useState, useEffect, useContext, useRef } from "react";
import EmpresaContext from "../../../../../../contexts/Empresa";
import api from "../../../../../../services/api";
import Avatar from "../../../Avatar";
import { Progress } from "reactstrap";

// svg
import goldPosition from "../../../../../../assets/img/PlayneeRanking/Ouro.svg";
import silverPosition from "../../../../../../assets/img/PlayneeRanking/Prata.svg";
import bronzePosition from "../../../../../../assets/img/PlayneeRanking/Bronze.svg";
//
import "./style.css";

interface Props {
  empresas: Array<any>;
  unidade: any;
  pageProperties: any;
  onTableChange(
    type: string,
    sortProperties: {
      page: number;
      sizePerPage: number;
      sortField: string;
      sortOrder: string;
    }
  ): Promise<void>;
  notify(type: string, msg: string): void;
  loading: boolean;
}

export const Ranking: React.FC<Props> = ({
  empresas,
  unidade,
  pageProperties,
  onTableChange,
  notify,
  loading,
  ...props
}) => {
  function convertToMoney(value: number) {
    if (unidade && unidade == "M") {
      return Number(value).toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      });
    } else {
      return parseInt(String(value));
    }
  }

  const { empresaSelecionada } = useContext(EmpresaContext);
  console.log(empresaSelecionada);

  const parseSafe = (val: any): number => {
    if (typeof val === "string") {
      // se contém vírgula (ex: "13.333,33")
      if (val.includes(",")) {
        return Number(val.replace(/\./g, "").replace(",", "."));
      }
      // se já vem em ponto (ex: "13333.33")
      return Number(val);
    }

    // se já é number
    if (typeof val === "number") return val;

    return 0;
  };

  const EmpresaItem: React.FC<{ data: any[] }> = ({ data }) => {
    return (
      <>
        {data.map((item, index) => {
          const vendas = parseSafe(item.vendas_geral);
          const meta = parseSafe(item.meta_geral);
          const superMeta = parseSafe(item.valor_supermeta);
          const percentual =
            meta > 0 ? Math.min(Math.round((vendas / meta) * 100), 100) : 0;

          const percentualSupermeta = superMeta
            ? Math.min(Math.round((vendas / superMeta) * 100), 100)
            : 0;
          const faltam = Math.max(0, meta - vendas);
          const faltamSupermeta = Math.max(0, superMeta - vendas);

          const isFirst = index === 0;
          const isSecond = index === 1;
          const isThird = index === 2;

          const borderColor = isFirst
            ? "#A5826D"
            : isSecond
            ? "#C0C0C0"
            : isThird
            ? "#CD7F32"
            : "#6F47FF";

          const badgeColor = borderColor;

          return (
            <div
              key={index + 1}
              className={`
              rankingLateralEmpresas
              d-flex
              align-items-center
              p-3
              mb-3
              rounded
              ${isFirst ? "destaque-primeiro" : ""}
            `}
            >
              {/* COLUNA ESQUERDA: avatar + número sobreposto */}
              <div className="mr-3">
                <div className="position-relative d-inline-block">
                  <Avatar
                    title={item.empresa.nome}
                    user={item.empresa}
                    className="avatar"
                    style={{
                      cursor: "default",
                      border: `3px ${borderColor} solid`,
                      width: "60px",
                      height: "60px",
                    }}
                    children={undefined}
                  />

                  {/* bolinha com o número do rank, sobreposta no canto */}
                  <div
                    className="position-absolute d-flex align-items-center justify-content-center rounded-circle text-white font-weight-bold"
                    style={{
                      width: 22,
                      height: 22,
                      bottom: -4,
                      left: 44,
                      background: badgeColor,
                      fontSize: 12,
                    }}
                  >
                    {index + 1}
                  </div>
                </div>
              </div>

              <div className="flex-grow-1">
                <p className="text-lg text-left text-white  font-weight-bold mb-1">
                  {item.empresa.nome}
                </p>

                <div className="d-flex align-items-center">
                  <Progress
                    value={percentual}
                    color="info"
                    barStyle={{
                      height: "10px",
                      borderBottomRightRadius: "0",
                      borderTopRightRadius: "0",
                    }}
                    style={{
                      width: `${percentual < 100 ? 100 : 70}%`,
                      height: "10px",
                      borderRadius: 0,
                      margin: 0,
                    }}
                  />

                  {percentual >= 100 && (
                    <Progress
                      value={percentualSupermeta}
                      color="danger"
                      barStyle={{
                        height: "10px",
                        borderBottomLeftRadius: "0",
                        borderTopLeftRadius: "0",
                      }}
                      animated
                      style={{
                        width: "30%",
                        height: "10px",
                        borderRadius: 0,
                        margin: 0,
                      }}
                    />
                  )}

                  <span className="ml-2 percentual-text">
                    {percentual < 100
                      ? `${percentual}%`
                      : `${percentualSupermeta}%`}
                  </span>
                </div>

                {/* Vendas / Meta / Faltam */}
                <div className="d-flex w-100  mt-2">
                  <div className="mr-3">
                    <span className="text-white text-sm">Vendas: </span>
                    <span className="text-sm text-white p-1 rounded-lg bg-success">
                      {convertToMoney(vendas)}
                    </span>
                  </div>

                  {percentual < 100 ? (
                    <div className="mr-3">
                      <span className="text-white text-sm">Meta: </span>
                      <span className="text-sm  text-white p-1 rounded-lg bg-info">
                        {convertToMoney(meta)}
                      </span>
                    </div>
                  ) : (
                    <div className="mr-3">
                      <span className="text-white text-sm">SuperMeta: </span>
                      <span className="text-sm text-white p-1 rounded-lg bg-danger">
                        {convertToMoney(superMeta)}
                      </span>
                    </div>
                  )}

                  {percentual < 100 ? (
                    <div className="mr-3">
                      <span className="text-white text-sm">Faltam: </span>
                      <span className="text-sm text-white p-1 rounded-lg bg-gray">
                        {convertToMoney(faltam)}
                      </span>
                    </div>
                  ) : (
                    <div className="mr-3">
                      <span className="text-white text-sm">Faltam: </span>
                      <span className="text-sm text-white p-1 rounded-lg bg-gray">
                        {convertToMoney(faltamSupermeta)}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </>
    );
  };

  // tentativa de retornar jsx com o card gold completo e posicionado

  const Gold: React.FC<{ data: any | null }> = ({ data }) => {
    if (data !== null) {
      return (
        <>
          {/* Escudo do ouro */}
          <img
            width={225}
            className=" position-relative "
            style={{ zIndex: 10 }}
            src={goldPosition}
          />

          {/* Conteúdo centralizado no escudo */}
          <div
            className="position-absolute d-flex flex-column align-items-center justify-content-center"
            style={{ zIndex: 10 }}
          >
            {/* Avatar maior para o primeiro lugar */}
            <Avatar
              size={120}
              title={data.empresa.nome}
              user={data.empresa}
              className="avatar"
              style={{
                cursor: "default",
              }}
              children={undefined}
            />

            {/* Card com nome (transparência a ser aplicada via HEX ou RGBA) */}
            <div
              className="d-flex flex-column align-items-center justify-content-center w-75 p-2 mt-2 rounded"
              style={{ background: "#FFFFFF33" }} // 20% de opacidade
            >
              <h2
                className="text-sm fw-bold mb-0 text-dark text-center"
                title={data?.empresa?.nome}
              >
                {data?.empresa?.nome}
              </h2>
            </div>
          </div>
        </>
      );
    }

    // fallback caso não exista dado
    return (
      <>
        <img className="goldPosition" src={goldPosition} />
        <div className="goldElipse">
          <div className="elipse" />
        </div>
      </>
    );
  };

  const Silver: React.FC<{ data: any | null }> = ({ data }) => {
    if (data !== null) {
      return (
        <>
          <img
            width={175}
            className=" position-relative"
            src={silverPosition}
          />

          <div className="position-absolute d-flex flex-column align-items-center justify-content-center  ">
            <Avatar
              size={100}
              title={data.empresa.nome}
              user={data.empresa}
              className="avatar"
              style={{
                cursor: "default",
              }}
              children={undefined}
            />

            <div className="d-flex flex-column align-items-center justify-content-center w-75  p-2  mt-2  opacity">
              <h2
                className=" text-sm fw-bold mb-0  text-dark text-center"
                title={data?.empresa?.nome}
              >
                {data?.empresa?.nome}
              </h2>
            </div>
          </div>
        </>
      );
    } else {
      return (
        <>
          <img className="silverPosition" src={silverPosition} />
          <div className="silverElipse">
            <div className="elipse" />
          </div>
        </>
      );
    }
  };

  const Bronze: React.FC<{ data: any | null }> = ({ data }) => {
    if (data !== null) {
      return (
        <>
          <img className="position-relative" src={bronzePosition} width={175} />

          <div className="position-absolute d-flex flex-column align-items-center justify-content-center top-50 start-50 translate-middle">
            <Avatar
              size={100}
              title={data.empresa.nome}
              user={data.empresa}
              className="avatar"
              style={{
                cursor: "default",
              }}
              children={undefined}
            />

            <div className="d-flex flex-column align-items-center justify-content-center w-75  p-2  mt-2  opacity">
              <h2
                className=" text-sm fw-bold mb-0  text-dark text-center"
                title={data?.empresa?.nome}
              >
                {data.empresa.nome.split(" ").slice(0, 3).join(" ")}
              </h2>
            </div>
          </div>

          {/* prêmio opcional */}
          {/* 
        <div className="premio">
          <div className="premioBronze" />
          <p>Chocolate</p>
        </div>
        */}
        </>
      );
    }

    return (
      <>
        <img className="bronzePosition" src={bronzePosition} />
        <div className="bronzeElipse">
          <div className="elipse" />
        </div>
      </>
    );
  };

  return (
    <div className="ranking">
      <div className="d-flex flex-column w-50 pt-4 align-items-center bg-ranking">
        <h1 className="text-white mb-4">Ranking {empresaSelecionada?.nome}</h1>

        <div
          className="
          d-flex flex-column flex-md-row w-100 gap-9
          align-items-center justify-content-center
          mt-auto mb-auto
          animate__animated animate__fadeInUp animate__slow
        "
        >
          <div className="d-flex align-items-center justify-content-center flex-column silverColaborador animate__animated animate__pulse animate__infinite animate__slow animate__delay-1s">
            <Silver data={empresas && empresas[1] ? empresas[1] : null} />
          </div>

          <div className="d-flex align-items-center justify-content-center index-gold flex-column goldColaborador animate__animated animate__pulse animate__infinite animate__slow">
            <Gold data={empresas && empresas[0] ? empresas[0] : null} />
          </div>

          <div className="d-flex align-items-center justify-content-center flex-column bronzeColaborador animate__animated animate__pulse animate__infinite animate__slow animate__delay-1s">
            <Bronze data={empresas && empresas[2] ? empresas[2] : null} />
          </div>
        </div>
      </div>

      <div className="rankingTenEmpresas">
        <EmpresaItem data={empresas} />
      </div>
    </div>
  );
};
